var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.display)?_c('CampaignEditForm',{attrs:{"campaign":_vm.campaign},on:{"finished":function($event){return _vm.close($event)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }